import { useIntl } from "react-intl";

import BannerAlert, { BannerProps } from "@/components/wpl/banner-alert/src";
import { useLocalizedHref } from "@/libraries/web-framework";
import { GlobalFooter } from "@/patterns/global-footer/src/index";

import { JiraSoftwarePageProps } from "../../../../pages/software/jira/anchors/jira-software-page";
import { ParentScrollTracking } from "../../../../utils/scroll-tracking";
import {
    BlogsSection,
    CTASection,
    DevOpsSection,
    LoggedInHeroSection,
    LoggedOutHeroSection,
    IntegrationSection,
    ScalingSection,
    TabsSection,
    WorkflowSection
} from "../sections/productionized/logged-in-jira";
import { filterAvailableJiraSites } from "../sections/productionized/logged-in-jira/logged-in-hero/logged-in-hero";
import JiraSoftwareNavV2 from "../sections/productionized/software-jira-navbar";

export const LoggedInJiraProductTourOverview = ({
    availableProducts,
    userProfile
}: JiraSoftwarePageProps) => {
    const intl = useIntl();
    const availableJiraSites = filterAvailableJiraSites(availableProducts);

    const aiBannerMessages: BannerProps = {
        identifier: "jira-software.banner-alert.atlassian-intelligence",
        text: intl.formatMessage({
            id: "jira-software.banner-alert.text",
            defaultMessage:
                "Transform teamwork with Atlassian Intelligence - now available."
        }),
        linkText: intl.formatMessage({
            id: "jira-software.banner-alert.link-text",
            defaultMessage: "Learn more"
        }),
        linkUrl: useLocalizedHref("/software/artificial-intelligence"),
        dataEventProps: {
            "data-product-key": "jiraSoftware",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Learn more",
            "data-label-english": "Learn more"
        }
    };

    // ATLAS-53087: Show welcome message and product link to logged in users with available Jira sites
    const HeroSection =
        userProfile && availableJiraSites.length > 0 ? (
            <LoggedInHeroSection
                availableJiraSites={availableJiraSites}
                userProfileName={userProfile?.name}
            />
        ) : (
            <LoggedOutHeroSection />
        );

    return (
        <div>
            <JiraSoftwareNavV2 />
            <ParentScrollTracking scrollTrackingEnabled={true} pageId="jsw">
                <BannerAlert {...aiBannerMessages} />
                {HeroSection}
                <TabsSection />
                <WorkflowSection />
                <IntegrationSection />
                <DevOpsSection />
                <BlogsSection />
                <ScalingSection />
                <CTASection />
                <GlobalFooter />
            </ParentScrollTracking>
        </div>
    );
};
